// @ts-check
/**
 * @file useSubscription.js
 * @location src/hooks/useSubscription.js
 * @role store S.subscription 을 기반으로 status·남은일·read-only 도출.
 *
 *  status:      'beta' | 'free' | 'trial' | 'active' | 'past_due' | 'cancelled'
 *  daysLeft:    trial 일 때만 number, 그 외 null
 *  isReadOnly:  past_due / cancelled — mutation 차단 신호
 *
 *  S.subscription 이 미설정(hydrate 전·미가입) 이면 status='trial' 디폴트
 *  (teams.subscription_status default 와 정합).
 */
import { useApp } from '../store/AppContext.jsx';

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export function useSubscription() {
  const { S } = useApp();
  const sub = S.subscription ?? { status: 'trial' };
  const status = sub.status;

  let daysLeft = null;
  if (status === 'trial' && sub.trialEndsAt) {
    const ms = new Date(sub.trialEndsAt).getTime() - Date.now();
    daysLeft = Math.max(0, Math.ceil(ms / ONE_DAY_MS));
  }

  const isReadOnly = status === 'past_due' || status === 'cancelled';
  const isFree = status === 'free';
  const isBeta = status === 'beta';

  return {
    status,
    daysLeft,
    trialEndsAt: sub.trialEndsAt ?? null,
    currentPeriodEnd: sub.currentPeriodEnd ?? null,
    isReadOnly,
    isFree,
    isBeta,
    hasCustomer: sub.hasCustomer ?? false,
    memberCap: sub.memberCap ?? null,
    teamId: sub.teamId ?? null,
  };
}
